// extracted by mini-css-extract-plugin
module.exports = {"title":"PublicCommitteeDetailsPage_title__2tXFt","divider":"PublicCommitteeDetailsPage_divider__1Mbdm"};